export default "__VITE_ASSET__Cda1Zont__"